import React from 'react';
import PropTypes from 'prop-types';

const FiletypeZipPath = ({ fill = '#738699' }) => {
  return (
    <path
      fill={fill}
      d="M25.316 9.681c.382.365.684 1.082.684 1.609v15.084c0 .898-.763 1.626-1.701 1.626H7.701C6.762 28 6 27.272 6 26.374V5.626C6 4.728 6.763 4 7.701 4h10.717c.539 0 1.261.293 1.639.654l5.259 5.027zM15 5.768c0 .125.11.232.245.232h1.25A.495.495 0 0 0 17 5.5c0-.268-.226-.5-.505-.5h-1.25a.238.238 0 0 0-.245.232v.536zM15.505 8h1.25A.238.238 0 0 0 17 7.768v-.536c0-.125-.11-.232-.245-.232h-1.25a.495.495 0 0 0-.505.5c0 .268.226.5.505.5zM15 9.768c0 .125.11.232.245.232h1.25A.495.495 0 0 0 17 9.5c0-.268-.226-.5-.505-.5h-1.25a.238.238 0 0 0-.245.232v.536zM15.505 12h1.25a.238.238 0 0 0 .245-.232v-.536c0-.125-.11-.232-.245-.232h-1.25a.495.495 0 0 0-.505.5c0 .268.226.5.505.5zm0 4h1.25a.238.238 0 0 0 .245-.232v-.536c0-.125-.11-.232-.245-.232h-1.25a.495.495 0 0 0-.505.5c0 .268.226.5.505.5zM15 13.768c0 .125.11.232.245.232h1.25a.495.495 0 0 0 .505-.5c0-.268-.226-.5-.505-.5h-1.25a.238.238 0 0 0-.245.232v.536zM15 21c0 .556.448 1 1 1 .556 0 1-.448 1-1v-3c0-.556-.448-1-1-1-.556 0-1 .448-1 1v3zm1-.5c.276 0 .5.232.5.5 0 .276-.232.5-.5.5a.505.505 0 0 1-.5-.5c0-.276.232-.5.5-.5z"
    />
  );
};

FiletypeZipPath.propTypes = {
  fill: PropTypes.string,
};

export default FiletypeZipPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/filetype/filetype-zip.jsx